import { DOCUMENT, Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { IUpdateContentBlock } from '../../../services/shared/update-announcements/update-announcement.interface';
import { UpdateContentHelper } from './update-content.helper';
import { IRenderedUpdateContentBlock } from './update-content.interface';


@Component({
	selector: 'app-update-content',
	templateUrl: './update-content.component.html',
	styleUrls: ['./update-content.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
	host: { '(click)': 'onLinkClick($event)' }
})
export class UpdateContentComponent {

	//** Component Events */
	@Output() readonly appRouteSelected: EventEmitter<void> = new EventEmitter<void>();

	//** Input Data */
	@Input() set blocks(blocks: IUpdateContentBlock[]) {
		this.renderedBlocks = UpdateContentHelper.renderBlocks(blocks, this.document.baseURI, (route: string) => this.location.prepareExternalUrl(route)).map((block: IRenderedUpdateContentBlock) => ({
			...block,
			videoEmbedUrl: block.type === 'video' && block.provider === 'youtube' && /^[\w-]{11}$/.test(block.youtubeId || '')
				? this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube-nocookie.com/embed/${block.youtubeId}`)
				: null
		}));
	}

	//** UI Variables */
	renderedBlocks: IRenderedUpdateContentBlock[] = [];


	constructor(
		@Inject(DOCUMENT) private readonly document: Document,
		private readonly sanitizer	: DomSanitizer,
		private readonly location	: Location,
		private readonly router		: Router
	) {}


	/**------------------------------------------------------
	 * UI Helpers
	 */
	//** Navigate without reloading the app */
	onLinkClick(event: MouseEvent): void {
		if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;

		const anchor: HTMLAnchorElement | null = event.target instanceof Element ? event.target.closest<HTMLAnchorElement>('a[href]') : null;
		if (!anchor || anchor.hasAttribute('download')) return;

		const route: string | null = UpdateContentHelper.getAppRoute(anchor.getAttribute('href'), this.document.baseURI);
		if (!route) return;

		event.preventDefault();
		this.appRouteSelected.emit();
		this.router.navigateByUrl(route);
	}
}
